var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { cn } from '../../lib/utils';
export var Progress = function (_a) {
    var value = _a.value, _b = _a.max, max = _b === void 0 ? 100 : _b, className = _a.className;
    var percentage = Math.min(Math.max((value / max) * 100, 0), 100);
    return (_jsx("div", __assign({ className: cn("w-full bg-secondary rounded-full h-2", className) }, { children: _jsx("div", { className: "bg-primary h-2 rounded-full transition-all duration-300 ease-in-out", style: { width: "".concat(percentage, "%") } }) })));
};
